import React from 'react';
import PanelHeader from '../../PanelHeader';

const Header = ({ size, isHidden }) => (
  <PanelHeader isHidden={isHidden}>{`${size} Bookings`}</PanelHeader>
);

export default Header;
